var runtime = require("../../../../build/webpack-environments/loaders/styles/myCssLoader/runtime.js");
module.exports = {"tag":"jxy8M"};
module.exports._getCss = function(wrap, process){return ""+wrap+" .jxy8M{margin-right:4px;margin-bottom:4px}" };
module.exports._meta = {moduleId: module.id, order: runtime.getOrder()};

